import { useEffect } from "react"

import moment from "moment"
import { useIntl } from "react-intl"

import { SessionDataStore } from "helpers/authUtils"
import { MEDALLIA_LAST_UPDATE } from "constants/medallia"
import { getFeedbackForm } from "components/FeedbackFooter"
import { putUserMedallia } from "components/UserManagement/service"
import { MedalliaHistory } from "components/UserManagement/interfaces"

const dateFormat = "MM/DD/yyyy"

const useMedalliaFeedback = () => {
	const intl = useIntl()
	const medalliaLastUpdate = localStorage.getItem(MEDALLIA_LAST_UPDATE)

	useEffect(() => {
		const now = moment()
		const nextFeedbackDueDate = moment(medalliaLastUpdate, dateFormat).add(
			2,
			"months"
		)
		if (!nextFeedbackDueDate.isValid() || nextFeedbackDueDate <= now) {
			getFeedbackForm(
				intl.formatMessage({ id: "phronesis.footer.feedback.subject" })
			)
			const email = SessionDataStore.getInstance().getEmail()
			const medalliaUpdatePayload: MedalliaHistory = {
				medallia_last_update: now.format(dateFormat),
			}
			putUserMedallia(email, medalliaUpdatePayload)
		}
	}, [intl, medalliaLastUpdate])
}

export default useMedalliaFeedback
